<select class="form-control" [(ngModel)]="selectedValue">
    <option value=""></option>
    <option *ngFor="let value of allValues" [ngValue]="value">{{ value }}</option>
</select>
